import api from "../../../api/api";

export const  businessDays = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
export const getWeekDayName = (dayNo) =>{
    return businessDays[dayNo-1];
}


const getAssociateBusinessHours = () => {
    return new Promise((resolve, reject)=>{
        api.get("associate/business-hours").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}









const scheduleServices = {
    getAssociateBusinessHours
}

export default scheduleServices;